<template>
  <div id="content" class="container">
    <div class="row">
      <div class="col-12">
        <h1>Lexique</h1>
      </div>
    </div>
    <div class="row definitions">
      <div class="col-12">
        <div v-for="(letter, index) in lexique" :key="index">
          <span class="letter">{{ letter.letter }}</span>
          <div
            v-for="(definition, index) in letter.definitions"
            :key="index"
            class="definition"
          >
            <span v-html="definition.titre"></span>
            <span v-html="definition.contenu"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <span class="top" @click.prevent="scrollTop"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Lexique",
  data() {
    return {
      lexique: [
        {
          letter: "A",
          definitions: [
            {
              titre: "Abandon card",
              contenu:
                "Les paniers abandonnés sont des emails automatiques envoyés dès lors qu&lsquo;un fan ne termine pas son parcours d&lsquo;achat et quitte le store avec un panier existant. Nécessite d&lsquo;avoir un compte dédié.",
            },
            {
              titre: "Add to collection",
              contenu:
                "Ajout <b>d&lsquo;une playlist</b>, d&lsquo;un titre ou d&lsquo;un album déjà sorti dans la bibliothèque du fan via les fonctions “save tracks” ou “save album” des boutons DSP dans Mira.",
            },
            {
              titre: "Autoshutdown",
              contenu:
                "Les campagnes Mira autoshutdown permettent de mettre en place une limite de participations à vos formulaires. C&lsquo;est utile dans le cadre de l&lsquo;organisation de releases parties avec un nombre limité de places, par exemple. Une fois la capacité maximale atteinte, le formulaire sera automatiquement indisponible.",
            },
          ],
        },
        {
          letter: "B",
          definitions: [
            {
              titre: "Back In Stock",
              contenu:
                "Les emails back in stock sont des emails automatiques qui annoncent aux fans qu&lsquo;un produit est de retour en stock sur le store.",
            },
            {
              titre: "Bases AA",
              contenu:
                "Un segment d&lsquo;audiences affinitaires est un ciblage d&lsquo;opt-ins Universal Music France ayant une affinité pour un artiste selon leurs achats, leurs visites sur nos stores, jeux concours, etc…",
            },
          ],
        },
        {
          letter: "C",
          definitions: [
            {
              titre: "CDP",
              contenu:
                "« Customer Data Platform ». Une CDP est un agrégateur de données, qui permet de faire de la segmentation de bases.",
            },
            {
              titre: "Compte dédié Dot Digital",
              contenu:
                "Un compte dédié Dot Digital est un compte dédié à un store/artiste qui permet d&lsquo;avoir une connexion directe à un store Shopify et d&lsquo;avoir des fonctionnalités de journey plus poussées (optins sur page de paiement des stores, mails de paniers abandonnés, etc…).",
            },
          ],
        },
        {
          letter: "D",
          definitions: [
            {
              titre: "Drop",
              contenu:
                "Drop est une solution payante vous permettant d&lsquo;interagir avec les communautés présentes sur Instagram. Contactez vos superfans directement via les DM Instagram ! Communiquez les dernières actus, boostez vos taux d&lsquo;engagement et créez une relation privilégiée entre les fans et vos artistes tout en collectant des données propriétaires. Se rapprocher de la team CRM pour plus de détails.",
            },
          ],
        },
        {
          letter: "F",
          definitions: [
            {
              titre: "Fan Pass",
              contenu:
                "Le Fan Pass Mira est une carte de membre/fidélité digitale gratuite, qui se glisse dans le wallet mobile des fans. Ce dernier permet de partager des exclusivités, d&lsquo;envoyer des notifications… Pour mettre en place un fan pass, rapprochez-vous de l&lsquo;équipe CRM.",
            },
            {
              titre: "Forever Presaves",
              contenu:
                "Les pages Forever Presaves vous permettent d&lsquo;ajouter tous les titres déjà sortis ainsi que tous les futurs titres de vos artistes dans la bibliothèque de vos fans (Spotify only). Seuls les repertoires owners ont le choix des titres à pousser.",
            },
          ],
        },
        {
          letter: "G",
          definitions: [
            {
              titre: "Groupe VIP Whatsapp",
              contenu:
                "Un groupe VIP WhatsApp est un groupe disponible dans l&lsquo;onglet &lsquo;conversations&lsquo; sur lequel les fans peuvent envoyer des messages, réagir à des messages des artistes… Possibilité de filtrer et plafonner les entrées. La solution est payante, se rapprocher de la team CRM pour plus de détails.",
            },
          ],
        },
        {
          letter: "H",
          definitions: [
            {
              titre: "Hotspot",
              contenu:
                "Un hotspot est une page Mira gratuite regroupant des zones cliquables sur une image statique, le fan peut donc naviguer avec sa souris pour découvrir des liens qui se cachent sur différents points de la page.",
            },
          ],
        },
        {
          letter: "J",
          definitions: [
            {
              titre: "Journey",
              contenu:
                "Une journey est un flow de newsletters automatiques envoyées à des fans, selon leurs actions/comportement. Exemple : paniers abandonnés.",
            },
          ],
        },
        {
          letter: "P",
          definitions: [
            {
              titre: "Playlist Creator",
              content:
                "Le playlist creator est un module de Mira permettant aux fans de créer leurs playlists à partir de titres que nous leur mettons à disposition. Ce module n&lsquo;est disponible que sur Spotify.",
            },
            {
              titre: "Pré-header",
              contenu:
                "Il s&lsquo;agit de la ligne grisée qui vient après l&lsquo;objet d&lsquo;un email. Il se situe en haut du contenu de l&lsquo;email, dans son en-tête. C&lsquo;est la première phrase du corps de l&lsquo;email qui apparaît en aperçu dans la boîte de réception du destinataire. Cela permet d&lsquo;afficher un teasing de votre newsletter lors de l&lsquo;affichage du mail dans la boîte de réception.",
            },
            {
              titre: "Presave",
              contenu:
                "Ajout d&lsquo;un titre ou d&lsquo;un album qui n&lsquo;est pas encore sur les plateformes dans la bibliothèque du fan via les fonctions “save tracks” ou “save album” des boutons DSP dans Mira.",
            },
          ],
        },
        {
          letter: "R",
          definitions: [
            {
              titre: "RGPD",
              contenu:
                'Le <a href="https://crm.universalmusic.fr/tuto/les-regles-du-rgpd" target="_blank" >RGPD</a> est un règlement européen concernant la collecte et l&lsquo;utilisation de données personnelles. Nous devons toujours veiller au respect de ce dernier, sous peine d&lsquo;amendes de la CNIL.',
            },
          ],
        },
        {
          letter: "S",
          definitions: [
            {
              titre: "Surprise & Delight",
              contenu:
                "Les campagnes Mira en surprise & delight vous permettront d&lsquo;avoir la liste de tous les participants au concours (pour gagner une place de concert, une listening party, un vinyle, du merch, collecter des fichiers de fans…) et/ou pour collecter du contenu de fans (vidéos, audios, photos…). ",
            },
            {
              titre: "Sweepstakes",
              contenu:
                "Les campagnes Mira en sweepstakes vous permettent de faire un tirage au sort automatique à la fin du concours (pour gagner une place de concert, une listening party, un vinyle, du merch…). Attention dans ce cas vous ne pourrez pas avoir toute la liste totale des participants mais seulement la liste de gagnants tirés au sort.",
            },
          ],
        },
        {
          letter: "T",
          definitions: [
            {
              titre: "Taux de délivrabilité",
              contenu:
                "La proportion des messages email considérés comme réellement parvenus à leur destinataire lors d&lsquo;une campagne.",
            },
            {
              titre: "Taux de désabonnement",
              contenu:
                "Nombre de désabonnements sur un email / nombre d&lsquo;emails envoyés * 100.",
            },
            {
              titre: "Taux d&lsquo;ouverture",
              contenu:
                "Nombre d&lsquo;emails ouverts/nombre d&lsquo;emails délivrés * 100.",
            },
            {
              titre: "Taux de réactivité (CTO) ",
              contenu:
                "Nombre de clics / Nombre d&lsquo;emails ouverts *100. Permet de savoir si le contenu poussé aux fans a plu. ",
            },
            {
              titre: "Tunecast",
              contenu:
                "Tunecast est une plateforme d&lsquo;écoute gratuite pour des listening parties digitales. Cette fonctionnalité Mira, vous permet de connecter les fans du monde entier pour leur faire découvrir de nouvelles sorties ou encore des playlists exclusives en temps réel avec d&lsquo;autres fans de musique. Vous pouvez aussi mettre en avant votre store sur la plateforme afin d&lsquo;apporter de la visibilité à vos produits. Un chat est disponible pour que les fans puissent échanger et il est possible de désigner des administrateurs et une liste de mots bannis pour la modération.",
            },
          ],
        },
        {
          letter: "W",
          definitions: [
            {
              titre: "Welcome email",
              contenu:
                "Un welcome email est un mail envoyé automatiquement dès lors qu&lsquo;un fan s&lsquo;inscrit à la base de données d&lsquo;un artiste/store. Ce mail permet de confirmer l&lsquo;inscription au fan tout en mettant en avant les DSP de l&lsquo;artiste, du merch et les dates de tournées. ",
            },
          ],
        },
      ],
    };
  },
  methods: {
    scrollTop: function () {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    this.$store.state.app_id = "lexique";
  },
};
</script>

<style lang="scss">
#lexique {
  #content {
    padding-top: 180px;

    & > div:first-child {
      background: url("../assets/img/contact-background.svg") no-repeat bottom
        right;
      background-size: contain;
    }
  }

  h1 {
    font-weight: 900;
    line-height: 103%;
    color: $blue-umf;
    margin-bottom: 40px;
  }

  .definitions {
    background-color: #ededed;
    color: $blue-umf;
    padding: 33px;

    .letter {
      display: flex;
      font-weight: 700;
      font-size: 2.5rem;
      line-height: 140%;
      margin-bottom: 20px;
    }

    .definition {
      background-color: #ffffff;
      border-radius: 30px;
      padding: 26px 32px;
      margin-bottom: 20px;
      font-weight: 400;
      font-size: 1.5rem;
      line-height: 133%;

      & > span:first-child {
        display: flex;
        font-weight: 700;
        font-size: 2rem;
        line-height: 140%;
        margin-bottom: 5px;
      }
    }
  }

  .top {
    display: block;
    width: 72px;
    height: 72px;
    background: $green-umf url("../assets/img/arrow-top.svg") no-repeat center
      center;
    cursor: pointer;
    margin: 33px auto 0;
    border-radius: 72px;
  }
}

@include media-breakpoint-down(lg) {
  #lexique {
    #content {
      & > div:first-child {
        background-size: contain;
        margin-bottom: 20px;
      }
    }
  }
}

@include media-breakpoint-down(md) {
}

@include media-breakpoint-up(md) {
  #lexique {
    .definitions {
      border-radius: 30px;
      padding: 50px;

      .definition {
        padding: 38px 78px;
      }
    }
  }
}

@include media-breakpoint-up(lg) {
  #lexique {
    #content {
      & > div:first-child {
        padding-bottom: 40px;
      }
    }

    h1 {
      margin-bottom: 100px;
    }

    .definitions {
      position: relative;
      top: -20px;
    }
  }
}
</style>
